import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$objeto;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataFetched ? _c('div', {
    staticClass: "card-form container"
  }, [_c('b-row', {
    class: "mb-5 d-flex justify-content-around",
    style: _vm.cardStyle
  }, [_c('div', [_c('img', {
    staticClass: "max-h-80px",
    attrs: {
      "alt": "Logo",
      "src": _vm.emissor.logo
    }
  })]), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.emissor.nome) + " - " + _vm._s(_vm.emissor.telefone))]), _vm._v(" "), _c('br'), _vm.emissor.cnpj_cpf.length < 14 ? _c('span', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _vm.emissor.cnpj_cpf.length >= 14 ? _c('span', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.logradouro, " - ").concat(_vm.emissor.numero, " - ").concat(_vm.emissor.bairro, ", ").concat(_vm.emissor.cep)))]), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.cidade, " - ").concat(_vm.emissor.uf)))]), _c('br')])]), _c('strong', [_vm._v("OS: ")]), _c('span', [_vm._v(" " + _vm._s(_vm.numero) + " ")]), !_vm.finished ? _c('div', [!_vm.isAnswered ? _c('div', [_c('b-tabs', {
    staticClass: "mt-3"
  }, [_c('b-tab', {
    attrs: {
      "title": "Gerais",
      "active": ""
    }
  }, [_c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Cliente",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Nome: ")]), _vm._v(_vm._s(_vm.cliente.nome)), _c('br'), _vm.cliente.cnpj_cpf !== null && _vm.cliente.cnpj_cpf.length < 14 ? _c('strong', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.cliente.cnpj_cpf)) + " "), _c('br')]) : _vm._e(), _vm.cliente.cnpj_cpf !== null && _vm.cliente.cnpj_cpf.length >= 14 ? _c('strong', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.cliente.cnpj_cpf))), _c('br')]) : _vm._e(), _vm.cliente.telefone !== null ? _c('strong', [_vm._v("Telefone:")]) : _vm._e(), _vm._v(_vm._s(_vm.cliente.telefone)), _c('br'), _vm.cliente.cep !== null ? _c('div', {
    staticStyle: {
      "white-space": "normal"
    }
  }, [_c('strong', [_vm._v("Endereço: ")]), _vm._v(" " + _vm._s(_vm.cliente.logradouro) + ", " + _vm._s(_vm.cliente.numero) + ", " + _vm._s(_vm.cliente.bairro) + ", " + _vm._s(_vm.cliente.complemento) + " " + _vm._s(_vm.cliente.cep) + ", " + _vm._s(_vm.cliente.cidade) + "-" + _vm._s(_vm.cliente.uf) + " ")]) : _vm._e()])], 1), _vm.identificadores.length > 0 ? _c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Objeto e Identificadores",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Objeto: ")]), _vm._v(_vm._s((_vm$objeto = _vm.objeto) === null || _vm$objeto === void 0 ? void 0 : _vm$objeto.descricao)), _c('br'), _vm._l(_vm.identificadores, function (identificador) {
    return _c('div', {
      key: identificador === null || identificador === void 0 ? void 0 : identificador.descricao
    }, [_c('strong', [_vm._v(_vm._s(identificador === null || identificador === void 0 ? void 0 : identificador.descricao) + ": ")]), _vm._v(" " + _vm._s(identificador === null || identificador === void 0 ? void 0 : identificador.value) + " ")]);
  })], 2)], 1) : _vm._e(), _vm.problema ? _c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Problema",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Descrevendo problema: ")]), _vm._v(_vm._s(_vm.problema)), _c('br')])], 1) : _vm._e(), _vm.produtos.length > 0 ? _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Produtos",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm.produtos.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.tableItems
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm.servicos.length > 0 ? _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Serviços",
      "tag": "article"
    }
  }, _vm._l(_vm.servicos, function (servico, index) {
    return _c('b-card-text', {
      key: servico.descricao
    }, [_c('label', [_vm._v(_vm._s(servico.discriminacao))]), typeof servico.observacao === 'string' && servico.observacao.trim() ? _c('div', {
      staticClass: "quebra-de-linha mb-2"
    }, [_c('strong', [_vm._v("Obs: ")]), _vm._v(_vm._s(servico.observacao) + " ")]) : _vm._e(), _c('b-table', {
      attrs: {
        "striped": "",
        "small": "",
        "hover": "",
        "items": _vm.tableServicoItems(index)
      }
    })], 1);
  }), 1) : _vm._e(), _vm.horarios && _vm.horarios.length > 0 ? _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Horários",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.tableHorarioItems
    }
  }), _c('b-row', {
    staticClass: "mt-3 font-weight-bold"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Totais")]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.totalHoras) + "h " + _vm._s(_vm.totalMinutos) + "m")]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.totalValor, 2)))])], 1)], 1)], 1) : _vm._e(), _vm.pagamentos ? _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Pagamentos",
      "tag": "article"
    }
  }, _vm._l(_vm.pagamentos, function (pagamento, index) {
    return _c('b-card-text', {
      key: pagamento.descricao
    }, [_c('label', [_vm._v(_vm._s(pagamento.forma_pagamento.descricao))]), _vm.pagamentos.length > 0 ? _c('b-table', {
      attrs: {
        "striped": "",
        "small": "",
        "hover": "",
        "items": _vm.tablePagamentoItems(index)
      }
    }) : _vm._e()], 1);
  }), 1) : _vm._e(), _c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Outras informações",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Observação: ")]), _c('div', {
    staticClass: "quebra-de-linha"
  }, [_vm._v(_vm._s(_vm.observacao))]), _c('br'), _c('strong', [_vm._v("Problema: ")]), _vm._v(" " + _vm._s(_vm.problema) + " "), _c('br'), _c('strong', [_vm._v("Desconto Geral R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.desconto, 2)) + " "), _c('br'), _c('strong', [_vm._v("Total da OS R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.valorTotal, 2)) + " "), _c('br'), _c('br'), _c('strong', [_vm._v("Data de entrada: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dataEntrada, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Data de saída: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dataSaida, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Data de previsão: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dataPrevisao, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Próxima revisão: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.proximaRevisao, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Data conclusão: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dataConclusao, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Hora Agendamento: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.horaAgendamento, "H:i:s")) + " "), _c('br'), _c('strong', [_vm._v("Solicitante: ")]), _vm._v(" " + _vm._s(_vm.solicitante) + " "), _c('br'), _c('strong', [_vm._v("Local do Atendimento: ")]), _vm._v(" " + _vm._s(_vm.local_atendimento) + " "), _c('br')]), _vm.menasgemOS ? _c('b-card-text', [_c('strong', [_vm._v("ESTOU CIENTE QUE APÓS 90 DIAS FICO SUJEITO A PERDA DO OBJETO POR MOTIVOS DE ABANDONO (ART. 1275, INCISO III DO CCB)")])]) : _vm._e()], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Anexos"
    }
  }, [_c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Anexos",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('label', [_vm._v("Anexo 1")]), _vm.anexo1 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo1,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br'), _c('label', [_vm._v("Anexo 2")]), _vm.anexo2 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo2,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br'), _c('label', [_vm._v("Anexo 3")]), _vm.anexo3 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo3,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br'), _c('label', [_vm._v("Anexo 4")]), _vm.anexo4 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo4,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br'), _c('label', [_vm._v("Anexo 5")]), _vm.anexo5 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo5,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br'), _c('label', [_vm._v("Anexo 6")]), _vm.anexo6 ? _c('a', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.anexo6,
      "target": "_blank"
    }
  }, [_vm._v(" Visualizar")]) : _vm._e(), _c('br')])], 1)], 1)], 1), _vm.status != 1 && _vm.status != 7 && _vm.status != 2 && _vm.status != 6 ? _c('span', {
    class: _vm.statusClass(_vm.status),
    attrs: {
      "slot": "status"
    },
    slot: "status"
  }, [_vm._v(" " + _vm._s(_vm.statusLabel(_vm.status)) + ", por " + _vm._s(_vm.contatoResposta) + " : " + _vm._s(_vm._f("moment")(_vm.dataResposta, "DD/MM/YYYY HH:mm:ss")) + " ")]) : _vm._e(), _vm.status == 1 || _vm.status == 7 || _vm.status == 2 || _vm.status == 6 ? _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-center"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Confirmar OS',
      expression: "'Confirmar OS'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": function click($event) {
        return _vm.handleClientResponse(true);
      }
    }
  }, [_vm._v(" Aprovar ")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Rejeitar OS',
      expression: "'Rejeitar OS'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-danger btn-hover-primary mr-2",
    on: {
      "click": function click($event) {
        return _vm.handleClientResponse(false);
      }
    }
  }, [_vm._v(" Rejeitar ")])]) : _vm._e()], 1) : _c('div', [_c('b-card', {
    staticClass: "my-2 border border-primary",
    attrs: {
      "title": "Confirmação",
      "tag": "article"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.allStatus
    },
    on: {
      "search": _vm.onSearchStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }], null, false, 3450419044),
    model: {
      value: _vm.statusClient,
      callback: function callback($$v) {
        _vm.statusClient = $$v;
      },
      expression: "statusClient"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1), _c('b-form-group', {
    attrs: {
      "label": "Nome do responsável",
      "label-for": "contato"
    }
  }, [_c('b-form-input', {
    staticClass: "contato-input",
    attrs: {
      "id": "contato",
      "name": "contato"
    },
    model: {
      value: _vm.contato,
      callback: function callback($$v) {
        _vm.contato = $$v;
      },
      expression: "contato"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": _vm.statusClient.id === 3 ? 'Observações' : 'Motivo',
      "label-for": "motivo"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "no-resize": "",
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.motivo,
      callback: function callback($$v) {
        _vm.motivo = $$v;
      },
      expression: "motivo"
    }
  })], 1), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-center"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Confirmar OS',
      expression: "'Confirmar OS'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    ref: "submit",
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": _vm.handleSendResponse
    }
  }, [_vm._v(" Enviar ")])])], 1)], 1)]) : _c('div', {
    staticClass: "mt-10 w-100 d-flex justify-content-center"
  }, [_c('strong', [_vm._v("Obrigado por sua resposta!")])]), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-end"
  }, [_c('img', {
    staticClass: "max-h-60px mr-5",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };